import { Component, Output, Input, EventEmitter, OnInit, ViewChild, ElementRef, inject } from "@angular/core";
import { DocumentDataService } from "@services/http/document/DocumentDataService";
import { NgxMasonryComponent, NgxMasonryModule } from "ngx-masonry";

declare var $: any;

@Component({
    selector: "cerrix-image-picker",
    templateUrl: "./cerrix-image-picker.component.html",
    styleUrls: ["./cerrix-image-picker.component.scss"],
    imports: [NgxMasonryModule],
})
export class CerrixImagePickerComponent implements OnInit {
    private _documentDs = inject(DocumentDataService);

    @Input() fallbackImageUrl: string;
    @Input() image: string;
    @Input() maxHeight: string = "100%";
    @Input() maxWidth: string = "100%";
    @Output() imageChange = new EventEmitter<string>();

    allImages: any[];

    @ViewChild("imageModal", { static: true }) imageModal: ElementRef;
    @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

    async ngOnInit() {
        this.allImages = await this._documentDs.GetImages();
    }

    applyImage(guid: string) {
        this.image = guid;
        this.imageChange.emit(this.image);
        this.hideModal();
    }

    showModal() {
        $(this.imageModal.nativeElement).modal("show");

        setTimeout(() => {
            if (this.masonry) {
                this.masonry.reloadItems();
                this.masonry.layout();
            }
        }, 250);
    }

    hideModal() {
        $(this.imageModal.nativeElement).modal("hide");
    }
}
